import { useEffect, useState } from 'react';
import { Box, Flex, Image, Text, VStack } from '@chakra-ui/react';
import Api from '../../Helper/ApiHandler';
import { CustomToast } from '../../Helper/Toast';

import Logo from '../../Assets/Logo.svg';

const PrivacyPolicy = ({ type }) => {
    const api = new Api();
    const [pageData, setPageData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            const { data } = await api.get(
                `auth/view-static-page?type=${type}`
            );
            setPageData(data);
            console.log('data: ', data);
        } catch (error) {
            CustomToast('error', error?.message || 'Something went wrong!');
        }
    };

    return (
        <>
            <Box height="100vh" display="flex" flexDirection="column">
                {/* Scrollable content */}
                <Box bg="gray.100" p={4} flex="1" overflowY="auto">
                    <Flex justify="center" p={4}>
                        <Image src={Logo} width="200px" alt="Logo" />
                    </Flex>
                    <Box bg="white" p={6} borderRadius="lg" boxShadow="md">
                        <VStack align="start" spacing={4}>
                            <Box
                                dangerouslySetInnerHTML={{
                                    __html: pageData?.content,
                                }}
                            />
                        </VStack>
                    </Box>
                </Box>

                {/* Footer */}
                <Box bg="gray.200" p={4} textAlign="center">
                    <Text>
                        &copy; {new Date().getFullYear()} - Just One Moment. All rights
                        reserved.
                    </Text>
                </Box>
            </Box>
        </>
    );
};

export default PrivacyPolicy;
